<template>
  <div :class="$t('OfficialVerification.official-class-name')">
    <page-navigate></page-navigate>
    <div class="topTip">
      <span class="tickTrack flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10.0003 18L9.83042 17.9342C4.37501 15.8256 3.74414 13.0694 3.74414 11.1797V3.96232L4.23116 3.97901C8.02324 4.10813 9.63797 2.39669 9.65319 2.37999L10.0008 2L10.3479 2.37999C10.3606 2.39374 11.8909 3.98589 15.3649 3.98589C15.3649 3.98589 15.3649 3.98589 15.3654 3.98589C15.4974 3.98589 15.6324 3.98392 15.7694 3.97901L16.2564 3.96232V11.1797C16.2564 13.0694 15.6256 15.8256 10.1702 17.9342L10.0003 18ZM4.68578 4.92752V11.1797C4.68578 12.196 4.68627 14.879 10.0003 16.9896C15.3148 14.879 15.3148 12.196 15.3148 11.1797V4.92752C12.3721 4.91623 10.6788 3.86904 10.0003 3.32801C9.32131 3.86855 7.62803 4.91525 4.68578 4.92752ZM5.78256 10.3967L6.75022 9.61264L8.68651 11.0413C8.68651 11.0413 11.3602 8.2753 13.9416 6.9846L14.3103 7.39994C14.3103 7.39994 11.0838 10.0736 9.42441 13.6237L5.78256 10.3967Z" fill="#A52933"/>
  <path d="M16.0967 4.12695L15.7754 4.13867L15.3652 4.14551C11.8409 4.14551 10.2695 2.53113 10.2305 2.48926L10.2295 2.48828L10.001 2.2373L9.77148 2.48828C9.72609 2.53779 8.06728 4.26948 4.22559 4.13867L3.9043 4.12695V11.1797C3.9043 12.1045 4.05786 13.23 4.87207 14.3828C5.68796 15.538 7.17921 16.7382 9.8877 17.7852L10 17.8281L10.1123 17.7852C12.8208 16.7383 14.312 15.5379 15.1279 14.3828C15.9421 13.23 16.0967 12.1045 16.0967 11.1797V4.12695ZM15.1553 5.08301C12.3969 5.03741 10.7435 4.09045 10 3.52637C9.25604 4.08992 7.60309 5.03646 4.8457 5.08301V11.1797C4.8457 11.6802 4.84661 12.5676 5.48633 13.5898C6.12257 14.6062 7.40433 15.7755 10 16.8164C12.5963 15.7754 13.8785 14.6063 14.5146 13.5898C15.1543 12.5676 15.1553 11.6802 15.1553 11.1797V5.08301ZM14.0615 6.87793L14.4297 7.29395L14.54 7.41797L14.4121 7.52344L14.4102 7.52441C14.4088 7.52557 14.4071 7.5279 14.4043 7.53027C14.3984 7.53522 14.3887 7.54274 14.377 7.55273C14.3535 7.57272 14.3184 7.60321 14.2734 7.64258C14.1832 7.72158 14.0522 7.8387 13.8896 7.99023C13.5638 8.29395 13.111 8.73574 12.6074 9.28809C11.5991 10.394 10.3896 11.9367 9.56934 13.6914L9.47852 13.8857L9.31836 13.7432L5.67676 10.5166L5.53516 10.3916L5.68164 10.2725L6.64941 9.48828L6.74609 9.41016L6.84473 9.48438L8.66992 10.8301C8.6773 10.8227 8.6852 10.8148 8.69336 10.8066C8.7722 10.7278 8.8879 10.6141 9.03418 10.4736C9.32672 10.1927 9.74329 9.80445 10.2412 9.37598C11.2356 8.5203 12.5618 7.49599 13.8701 6.8418L13.9795 6.78613L14.0615 6.87793ZM13.9053 7.18457C12.6672 7.82288 11.4099 8.79237 10.4502 9.61816C9.95752 10.0421 9.54518 10.4262 9.25586 10.7041C9.11127 10.843 8.99738 10.9557 8.91992 11.0332L8.80859 11.1445C8.80634 11.1468 8.80493 11.1491 8.80371 11.1504L8.80176 11.1523L8.7041 11.2529L6.75488 9.81445L6.0293 10.4023L9.37207 13.3633C10.2076 11.6486 11.388 10.1505 12.3711 9.07227C12.8815 8.51248 13.3399 8.06438 13.6709 7.75586C13.8364 7.60156 13.9709 7.48242 14.0635 7.40137C14.0701 7.39557 14.0758 7.38919 14.082 7.38379L13.9053 7.18457ZM15.4746 11.1797C15.4746 11.6954 15.4749 12.6579 14.7861 13.7588C14.0984 14.8578 12.7377 16.0751 10.0596 17.1387L10 17.1621L9.94141 17.1387C7.26351 16.0751 5.90261 14.8578 5.21484 13.7588C4.52594 12.6579 4.52539 11.6954 4.52539 11.1797V4.76855L4.68555 4.76758C7.58615 4.75538 9.24522 3.72461 9.90039 3.20312L10 3.12305L10.0996 3.20312C10.7541 3.72497 12.4137 4.75644 15.3154 4.76758L15.4746 4.76855V11.1797ZM16.416 11.1797C16.416 12.1445 16.2547 13.3425 15.3896 14.5674C14.5262 15.7898 12.974 17.0214 10.2275 18.083L10 18.1719L9.77246 18.083C7.02605 17.0214 5.47369 15.7898 4.61035 14.5674C3.74532 13.3426 3.58398 12.1445 3.58398 11.1797V3.79688L3.75 3.80273L4.23633 3.81934C7.94519 3.94562 9.52183 2.28629 9.53516 2.27246L9.88281 1.8916L10.001 1.7627L10.1191 1.89258L10.4648 2.27148L10.5322 2.33496C10.8457 2.61679 12.2657 3.74128 15.0498 3.82129L15.3652 3.82617C15.4957 3.82617 15.6289 3.82417 15.7637 3.81934L16.251 3.80273L16.416 3.79688V11.1797Z" fill="#A52933"/>
</svg>
        <span class="tickWord">
          防诈提醒：请核实 <span class="medium"> EBC官方网站 </span> 与
          <span class="medium"> 官方渠道 </span>信息，避免受骗风险
        </span>
      </span>
    </div>
    <section class="container1">
      <div class="top contentBox flex justify-between">
        <div class="left">
          <h1 class="super_large-80_bold md-title-32_bold">
            <span class="redWord">EBC官方</span>验证中心
          </h1>
          <h2 class="subtitle-20_regular md-body-14_regular">
            为防止不法分子盗用EBC名义谋利，您可以粘贴可疑网站链接，核验是否为
            EBC 官方渠道
          </h2>
          <div class="inputBox flex items-center">
            <input class="body-14_regular md-footnote-regular_12" type="text" name="url" id="url"
              placeholder="请输入完整网站链接" v-model="url" />
            <button id="verification" class="primary-default_large" @click="verifyUrl">
              查询验证
            </button>
          </div>
        </div>
        <img src="@/assets/image/OfficialVerification/container1Model.png" class="right" alt="" />
      </div>
      <div class="bottom contentBox">
        <h2 class="title-24_bold title md-subtitle-18_medium">
          EBC 官方声明
        </h2>
        <div class="tipTitle content-16_medium md-content-14_medium">
          授权交易平台
        </div>
        <div class="tipDesc content-16_regular md-content-14_regular">
          EBC 仅提供官方 MetaTrader 4 (MT4) 和 MetaTrader 5 (MT5)
          交易平台。为确保您的账户安全，请务必通过 EBC 官方网站 (www.ebc.com)
          下载并安装交易软件。
        </div>
        <div class="tipTitle content-16_medium md-content-14_medium">
          不提供投资建议或收益保证
        </div>
        <div class="tipDesc content-16_regular md-content-14_regular">
          EBC
          不提供任何形式的投资建议，亦不对交易收益作出任何承诺或保证。请您在交易前自行进行充分的研究和风险评估。
        </div>
        <div class="tipTitle content-16_medium md-content-14_medium">
          对非法行为的零容忍政策
        </div>
        <div class="tipDesc content-16_regular md-content-14_regular">
          EBC 严厉谴责任何盗用 EBC
          名义从事非法活动的行为。我们将依法采取果断措施，追究相关责任人的法律责任。如您发现任何可疑活动，请保留相关证据并立即联系我们的客服团队或发送邮件至
          cs@ebc.com。我们将迅速响应，并为受影响的客户提供必要的支持，包括法律协助。
        </div>
      </div>
    </section>
    <section class="container2">
      <div class="contentBox">
        <h2 class="title-48_bold md-title-24_bold text-center">
          安全提示
        </h2>
        <div class="cardList flex" style="display: none;">
          <div class="card flex items-center">
            <div class="left">
              <h3 class="subtitle-20_medium md-subtitle-18_medium">
                识破虚假信息
              </h3>
              <div class="description content-16_regular md-content-14_regular">
                快速辨别伪造消息、假网站和虚假活动，保护个人信息与账户安全
              </div>
              <!-- <a href="">
              <div class="secondary-default_medium btn">
                了解更多
                <span class="iconfont icon-right-round"></span>
              </div>
              </a> -->
            </div>
            <img src="@/assets/image/OfficialVerification/container2Logo1.png" alt="" class="right" />
          </div>
          <div class="card flex items-center">
            <div class="left">
              <h3 class="subtitle-20_medium md-subtitle-18_medium">
                网络防诈指南
              </h3>
              <div class="description content-16_regular md-content-14_regular">
                移动设备与钓鱼网站常见手法揭秘，识别钓鱼网站和移动诈骗
              </div>
              <!-- <a href="">
              <div class="secondary-default_medium btn">
                了解更多
                <span class="iconfont icon-right-round"></span>
              </div>
              </a> -->
            </div>
            <img src="@/assets/image/OfficialVerification/container2Logo2.png" alt="" class="right" />
          </div>
        </div>
      </div>
    </section>
    <section class="container22">
      <div class="contentBox suggestDo">
        <div class="doTitle title-24_bold md-subtitle-18_medium">建议这样做</div>
        <div class="doTip">
          <img src="@/assets/image/OfficialVerification/suggestDo.svg" alt="">
          务必通过EBC官方网站及官方公布的联系方式（www.ebc.com）核验您所接收的一切信息。
        </div>
        <div class="doTip">
          <img src="@/assets/image/OfficialVerification/suggestDo.svg" alt="">
          请为自己留出充足的思考时间，谨慎做出投资决策。警惕任何以“限时机会”、“内部消息”为名的催促行为。
        </div>
        <div class="doTip">
          <img src="@/assets/image/OfficialVerification/suggestDo.svg" alt="">
          若收到疑似冒充EBC的电话、邮件或短信，请勿回复、点击或接听。请务必截图存证，并通过官方邮箱（cs@ebc.com）联系我们进行核实与举报。
        </div>
      </div>
      <div class="contentBox dontDo">
        <div class="doTitle title-24_bold md-subtitle-18_medium">不要做</div>
        <div class="doTip">
          <img src="@/assets/image/OfficialVerification/dontDo.svg" alt="">
          请勿下载来自非官方渠道的软件或APP，不要点击来源不明的链接或附件，以防恶意软件与钓鱼攻击。
        </div>
        <div class="doTip">
          <img src="@/assets/image/OfficialVerification/dontDo.svg" alt=""> 绝不向任何未经官方核验的人员或平台透露您的银行账户、信用卡信息。
        </div>
        <div class="doTip">
          <img src="@/assets/image/OfficialVerification/dontDo.svg" alt=""> 不要泄露或共享您的密码、短信/邮箱验证码；不要接受安装远程控制软件。
        </div>
        <div class="doTip">
          <img src="@/assets/image/OfficialVerification/dontDo.svg" alt=""> 不要相信“保本/保证收益/代客操盘/返利群”等承诺，尤其伴随催促转账或拉群。
        </div>
      </div>
    </section>
    <section class="container3">
      <div class="contentBox flex justify-between items-center">
        <div class="left">
          <h3 class="title-48_bold md-title-24_bold">法律支持与援助</h3>
          <div class="description body-16_regular md-body-14_regular">
            如您遭遇仿冒网站、可疑链接或已发生资金损失，请立即与我们联系。EBC
            将核实线索、提供取证指导，并在合规范围内协助您与相关机构沟通，维护您的合法权益。
          </div>
          <div class="contactWay body-16_regular md-body-14_regular">
            如有任何疑问或需报告可疑活动，请通过电子邮件<div class="email body-16_medium md-body-16_medium" @click="copyDeal('cs@ebc.com')">
              cs@ebc.com
            </div>联系我们的客服团队。EBC 致力于保护客户权益并维护品牌诚信。
          </div>
        </div>
        <img src="@/assets/image/OfficialVerification/container3Logo.png" alt="" class="right" />
      </div>
    </section>

    <div class="official-result-box" v-show="isOfficialResultBoxVisible">
      <input id="messageStatus" type="hidden" v-model="messageStatus">
      <div class="official-result" v-show="isOfficialResultVisible">
        <div class="result-true" v-show="isResultTrue">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
            <path
              d="M54.6331 9.36618C51.6629 6.39197 48.1346 4.03356 44.2507 2.42628C40.3668 0.819003 36.2037 -0.00550645 32.0004 6.752e-05C27.7966 -0.0085854 23.6327 0.81452 19.7484 2.42198C15.8641 4.02943 12.3362 6.38948 9.36792 9.36618C-3.12069 21.8462 -3.12069 42.1525 9.36792 54.6324C12.3364 57.609 15.8643 59.9689 19.7485 61.5764C23.6328 63.1838 27.7967 64.007 32.0004 63.9986C36.2047 64.0108 40.3697 63.1893 44.2546 61.5817C48.1394 59.974 51.6669 57.6121 54.6331 54.6324C67.1229 42.1525 67.1229 21.8461 54.6331 9.36618ZM50.9345 23.6381L29.438 46.5082C29.3373 46.6214 29.2112 46.7091 29.07 46.7642C28.9605 46.838 28.8879 46.9119 28.7402 46.9463C28.4747 47.0631 28.1884 47.125 27.8983 47.1285C27.6241 47.1196 27.3526 47.0711 27.0922 46.9845L26.8362 46.8368C26.6828 46.7647 26.5362 46.679 26.3981 46.5808L14.0917 34.4689C13.8792 34.2661 13.711 34.0216 13.5975 33.7507C13.4839 33.4798 13.4276 33.1884 13.4319 32.8947C13.4319 32.3088 13.6559 31.723 14.0559 31.3205C14.4797 30.915 15.0436 30.6887 15.6301 30.6887C16.2166 30.6887 16.7805 30.915 17.2042 31.3205L27.8282 41.7845L47.7124 20.6387C48.1268 20.227 48.6815 19.9871 49.2653 19.967C49.8491 19.9469 50.419 20.1482 50.8607 20.5304C51.0815 20.7287 51.2579 20.9715 51.3781 21.2428C51.4984 21.5141 51.5599 21.8078 51.5586 22.1046C51.5566 22.6779 51.333 23.2283 50.9346 23.6406L50.9345 23.6381Z"
              fill="#52C41A" />
          </svg>
          <p class="resultTitle real title-40_bold md-title-24_bold">
            已验证
          </p>
          <p class="tips real subtitle-20_regular md-footnote-regular_12">
            您查询的信息已通过官方验证
          </p>
          <p class="url real subtitle-20_medium md-body-14_regular">{{ resultUrl }}</p>
          <div class="buttons">
            <a href="javascript:void(0);" class="primary-default_large close" @click="resetSearch">确认</a>
            <!-- <a href="javascript:void(0);" class="report real"></a> -->
          </div>
          <p class="tips2 real"></p>
        </div>
        <div class="result-false" v-show="!isResultTrue">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
            <path
              d="M32 0C14.3284 0 0 14.3284 0 32C0 49.6716 14.3284 64 32 64C49.6716 64 64 49.6716 64 32C64 14.3284 49.6716 0 32 0ZM29.7143 16.5714C29.7143 16.2575 29.9718 16 30.2857 16H33.7143C34.0282 16 34.2857 16.2575 34.2857 16.5714V36C34.2853 36.1514 34.225 36.2965 34.1179 36.4036C34.0108 36.5107 33.8657 36.571 33.7143 36.5714H30.2857C30.1343 36.571 29.9892 36.5107 29.8821 36.4036C29.775 36.2965 29.7147 36.1514 29.7143 36V16.5714ZM32 48C31.0905 47.9998 30.2183 47.6383 29.5753 46.995C28.9323 46.3518 28.5712 45.4794 28.5714 44.5699C28.5716 43.6604 28.9331 42.7882 29.5764 42.1452C30.2197 41.5022 31.092 41.1411 32.0015 41.1413C32.4519 41.1414 32.8978 41.2302 33.3138 41.4027C33.7298 41.5751 34.1078 41.8278 34.4262 42.1463C34.7446 42.4648 34.9971 42.8429 35.1693 43.259C35.3416 43.6751 35.4302 44.1211 35.4301 44.5714C35.43 45.0218 35.3412 45.4677 35.1688 45.8837C34.9963 46.2997 34.7436 46.6777 34.4251 46.9961C34.1066 47.3145 33.7285 47.567 33.3124 47.7393C32.8963 47.9115 32.4503 48.0001 32 48Z"
              fill="#FF4B4E" />
          </svg>
          <p class="resultTitle real title-40_bold md-title-24_bold">
            未验证
          </p>
          <p class="tips subtitle-20_regular md-footnote-regular_12">
            您查询的信息未经官方验证，请不要与未经验证的渠道互动
          </p>
          <p class="url subtitle-20_medium md-body-14_regular">
            <span class="txt">{{ resultUrl }}</span>
            <a href="javascript:void(0);" class="report subtitle-20_medium pcReport" @click="showReportForm">举报</a>
          </p>
          <div class="buttons">
            <a href="javascript:void(0);" class="report secondary-default_medium mReport" @click="showReportForm">举报</a>
            <a href="javascript:void(0);" class="primary-default_large close" @click="resetSearch">确认</a>
          </div>
          <p class="tips2 body-16_regular md-footnote-regular_12">
            如果您认为该信息涉嫌虚假盗用，请向我们提交举报
          </p>
        </div>
      </div>

      <div class="official-report" v-show="isOfficialReportVisible">
        <p class="title title-40_bold md-title-24_bold">举报</p>
        <div class="formContainer" style="max-height: 40vh;overflow-y: auto;padding-right:5px">
          <div class="form-box-head">
            <p class="form-label mt110">举报地址</p>
            <div class="row">
              <div class="col-md-12"><input id="report-url" name="report-url" type="text" v-model="reportUrl"
                  class="form-control"></div>
            </div>
          </div>
          <div class="form-box" v-show="isFormBoxVisible">
            <p class="form-label mt110">{{ $t('OfficialVerification.official-page3.text10') }}</p>
            <div class="row">
              <div class="col-md-12"><input id="name" name="name" type="text" v-model="name" class="form-control"
                  :placeholder="$t('OfficialVerification.official-page3.text11')"></div>
            </div>
            <p class="form-label">{{ $t('OfficialVerification.official-page3.text12') }}</p>
            <div class="row">
              <div class="col-md-12"><input id="phone-email" name="email" type="text" v-model="email"
                  class="form-control" :placeholder="$t('OfficialVerification.official-page3.text13')"></div>
            </div>
            <p class="form-label">{{ $t('OfficialVerification.official-page3.text14') }}</p>
            <div class="row">
              <div class="col-md-12"><input id="phone" name="phone" type="text" v-model="phone" class="form-control"
                  :placeholder="$t('OfficialVerification.official-page3.text15')"></div>
            </div>
            <p class="form-label">{{ $t('OfficialVerification.official-page3.text16') }}</p>
            <div class="row">
              <div class="col-md-12"><input id="message_content" name="message_content" type="text"
                  v-model="messageContent" class="form-control"
                  :placeholder="$t('OfficialVerification.official-page3.text17')"></div>
            </div>
          </div>

          <p class="form-label">{{ $t('OfficialVerification.official-page3.text18') }}</p>
          <div class="verifyContainer">
            <div class="verify-input" style="float: left;">
              <input id="verify" style="width: 100%;" type="text" v-model="code" class="form-control"
                :placeholder="$t('OfficialVerification.official-page3.text19')" required>
            </div>
            <div class="verify-code" style="float: left;">
              <div @click="refreshCode">
                <ss-code :identifyCode="identifyCode"></ss-code>
              </div>
            </div>
          </div>
        </div>

        <p class="message-tips message-open-tips body-14_medium" v-show="!isFormBoxVisible">
          <a href="javascript:void(0);" id="message" @click="toggleFormBox">点击此处留言
            <span class="iconfont icon-right" style="transform: rotate(90deg); display: inline-block"></span>
          </a>
        </p>
        <p class="message-tips message-close-tips body-14_medium" v-show="isFormBoxVisible">
          <a href="javascript:void(0);" id="message_close" @click="toggleFormBox">
            收起留言
            <span class="iconfont icon-right" style="transform: rotate(-90deg); display: inline-block"></span>
          </a>
        </p>
        <div class="buttons flex">
          <a href="javascript:void(0);" class="secondary-default_large close" @click="resetSearch">取消</a>
          <a href="javascript:void(0);" id="official-contact-submit" class="primary-default_large"
            @click="handleSubmit">提交举报</a>
        </div>
      </div>

      <div class="official-report-success" v-show="isOfficialReportSuccessVisible">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
          <path
            d="M54.6331 9.36618C51.6629 6.39197 48.1346 4.03356 44.2507 2.42628C40.3668 0.819003 36.2037 -0.00550645 32.0004 6.752e-05C27.7966 -0.0085854 23.6327 0.81452 19.7484 2.42198C15.8641 4.02943 12.3362 6.38948 9.36792 9.36618C-3.12069 21.8462 -3.12069 42.1525 9.36792 54.6324C12.3364 57.609 15.8643 59.9689 19.7485 61.5764C23.6328 63.1838 27.7967 64.007 32.0004 63.9986C36.2047 64.0108 40.3697 63.1893 44.2546 61.5817C48.1394 59.974 51.6669 57.6121 54.6331 54.6324C67.1229 42.1525 67.1229 21.8461 54.6331 9.36618ZM50.9345 23.6381L29.438 46.5082C29.3373 46.6214 29.2112 46.7091 29.07 46.7642C28.9605 46.838 28.8879 46.9119 28.7402 46.9463C28.4747 47.0631 28.1884 47.125 27.8983 47.1285C27.6241 47.1196 27.3526 47.0711 27.0922 46.9845L26.8362 46.8368C26.6828 46.7647 26.5362 46.679 26.3981 46.5808L14.0917 34.4689C13.8792 34.2661 13.711 34.0216 13.5975 33.7507C13.4839 33.4798 13.4276 33.1884 13.4319 32.8947C13.4319 32.3088 13.6559 31.723 14.0559 31.3205C14.4797 30.915 15.0436 30.6887 15.6301 30.6887C16.2166 30.6887 16.7805 30.915 17.2042 31.3205L27.8282 41.7845L47.7124 20.6387C48.1268 20.227 48.6815 19.9871 49.2653 19.967C49.8491 19.9469 50.419 20.1482 50.8607 20.5304C51.0815 20.7287 51.2579 20.9715 51.3781 21.2428C51.4984 21.5141 51.5599 21.8078 51.5586 22.1046C51.5566 22.6779 51.333 23.2283 50.9346 23.6406L50.9345 23.6381Z"
            fill="#52C41A" />
        </svg>
        <p class="title-32_medium md-title-24_bold">已提交，感谢您的反馈</p>
        <a href="javascript:void(0);" class="primary-default_large close" @click="resetSearch">关闭</a>
      </div>
    </div>
    <page-footer></page-footer>
  </div>

</template>

<script>
import 'swiper/css/swiper.css'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      url: '',
      lang: this.$t('OfficialVerification.lang'),
      messageStatus: 0,
      isOfficialResultBoxVisible: false,
      isOfficialResultVisible: false,
      isResultTrue: false,
      resultUrl: '',
      isOfficialReportVisible: false,
      isFormBoxVisible: false,
      reportUrl: '',
      name: '',
      email: '',
      phone: '',
      messageContent: '',
      isOfficialReportSuccessVisible: false,
      code: null,
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz", //随机串内容,从这里随机抽几个显示验证码
      identifyCode: "", //验证码图片内容
    };
  },
  mounted() {
    // 初始化验证码
    this.identifyCode = "";
    //参数：（1）随机串内容。（2）验证码显示位数
    this.makeCode(this.identifyCodes, 4);
    document.documentElement.setAttribute('data-fitter', 'true');
    
  },
  methods: {
    copyDeal(text){
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(() => {
            this.showAlert('复制成功')
          }).catch(err => {
            console.error('复制失败:', err);
          });
        }
    },
    // 重置验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //获取验证码的值
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        //通过循环获取字符串内随机几位
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    //随机数字：用于当角标拿字符串的值
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    verifyUrl() {
      const langMessages = {
        cn: "请输入完整网站链接",
        en: "Please enter the full website URL",
        tw: "請輸入完整網站鏈接",
        ja: "完全なウェブサイトのURLを入力してください",
        ko: "전체 웹사이트 URL을 입력하십시오",
        th: "กรุณาใส่ URL ของเว็บไซต์ให้ครบถ้วน",
        vn: "Vui lòng nhập URL đầy đủ của trang web",
        ug: "تولۇق تور بەت ئادرېسىنى كىرگۈزۈڭ",
      };

      const langMessages2 = {
        cn: "请输入有效的网站链接",
        en: "Please enter a valid website URL",
        tw: "請輸入有效的網站鏈接",
        ja: "有効なウェブサイトのリンクを入力してください",
        ko: "유효한 웹사이트 링크를 입력하십시오",
        th: "กรุณาใส่ลิงก์ของเว็บไซต์ที่ถูกต้อง",
        vn: "Vui lòng nhập liên kết hợp lệ của trang web",
        ug: "ئىناۋەتلىك تور بەت ئۇلىنىشىنى كىرگۈزۈڭ",
      };

      if (this.url === '') {
        this.showAlert(langMessages[this.lang] || "Please enter the full website URL")
        return;
      }
      if (!this.isValidDomain(this.url)) {
        this.showAlert(langMessages2[this.lang] || "Please enter a valid website URL")
        return;
      }
      this.$http('https://www.ebccfd.com/VerificationAuthenticity', {
        url: this.url,
        lang: this.lang,
      })
        .then((response) => {
          const da = response.data;
          this.showResultBox = true; // 显示结果盒子
          this.showReport = false; // 隐藏报告
          this.showReportSuccess = false; // 隐藏报告成功信息
          this.showOfficialResult = true; // 显示官方结果
          if (da.code === 1) {
            this.isOfficialResultBoxVisible = true;
            this.isOfficialResultVisible = true;
            this.isResultTrue = true;
            this.resultUrl = da.url;
            this.reportUrl = da.url;
          } else {
            this.isOfficialResultBoxVisible = true;
            this.isOfficialResultVisible = true;
            this.isResultTrue = false;
            this.resultUrl = da.url;
            this.reportUrl = da.url;
          }
        })
        .catch((error) => {
          console.error('There was an error!', error);
        });
    },
    resetSearch() {
      this.url = '';
      this.isOfficialResultBoxVisible = false;
      this.isOfficialResultVisible = false;
      this.isOfficialReportVisible = false;
      this.isFormBoxVisible = false;
      this.isOfficialReportSuccessVisible = false;
    },
    showReportForm() {
      this.isOfficialReportVisible = true;
    },
    toggleFormBox() {
      this.isFormBoxVisible = !this.isFormBoxVisible;
      this.messageStatus = this.isFormBoxVisible ? 1 : 0;
    },
    setMessages() {
      const langMessages = {
        cn: {
          msg_report_url: "请输入网站地址",
          msg_name: "请输入您的称呼!",
          msg_email: "请输入您的邮箱!",
          msg_phone: "请输入您的手机号!",
          msg_verify: "请输入验证码!",
          msg_message_content: "请输入信息反馈"
        },
        en: {
          msg_report_url: "Please enter the website address",
          msg_name: "Please enter your name",
          msg_email: "Please enter your email",
          msg_phone: "Please enter your phone number",
          msg_message_content: "Please enter your feedback",
          msg_verify: "Please enter the verification code",
          msg_verify_error: "Verification code error, please re-enter"
        },
        tw: {
          "msg_report_url": "請輸入網站地址",
          "msg_name": "請輸入您的稱呼!",
          "msg_email": "請輸入您的郵箱!",
          "msg_phone": "請輸入您的手機號!",
          "msg_verify": "請輸入驗證碼!",
          "msg_message_content": "請輸入信息反饋"
        },
        ja: {
          "msg_report_url": "ウェブサイトのアドレスを入力してください",
          "msg_name": "お名前を入力してください!",
          "msg_email": "メールアドレスを入力してください!",
          "msg_phone": "電話番号を入力してください!",
          "msg_verify": "確認コードを入力してください!",
          "msg_message_content": "フィードバックを入力してください"
        },
        ko: {
          "msg_report_url": "웹사이트 주소를 입력하세요",
          "msg_name": "이름을 입력하세요!",
          "msg_email": "이메일을 입력하세요!",
          "msg_phone": "전화번호를 입력하세요!",
          "msg_verify": "인증 코드를 입력하세요!",
          "msg_message_content": "피드백을 입력하세요"
        },
        th: {
          "msg_report_url": "กรุณาใส่ที่อยู่เว็บไซต์",
          "msg_name": "กรุณาใส่ชื่อของคุณ!",
          "msg_email": "กรุณาใส่อีเมลของคุณ!",
          "msg_phone": "กรุณาใส่หมายเลขโทรศัพท์ของคุณ!",
          "msg_verify": "กรุณาใส่รหัสยืนยัน!",
          "msg_message_content": "กรุณาใส่ข้อความของคุณ"
        },
        vn: {
          "msg_report_url": "Vui lòng nhập địa chỉ trang web",
          "msg_name": "Vui lòng nhập tên của bạn!",
          "msg_email": "Vui lòng nhập email của bạn!",
          "msg_phone": "Vui lòng nhập số điện thoại của bạn!",
          "msg_verify": "Vui lòng nhập mã xác minh!",
          "msg_message_content": "Vui lòng nhập phản hồi của bạn"
        },
        ug: {
          "msg_report_url": "تور بېتى ئادىرسىنى كىرگۈزۈڭ",
          "msg_name": "ئىسمىڭىزنى كىرگۈزۈڭ!",
          "msg_email": "ئېلخەت ئادرېسىڭىزنى كىرگۈزۈڭ!",
          "msg_phone": "يانفون نومۇرىڭىزنى كىرگۈزۈڭ!",
          "msg_verify": "دەلىللەش كودىنى كىرگۈزۈڭ!",
          "msg_message_content": "پىكىر-بايانىڭىزنى كىرگۈزۈڭ"
        },
      };
      this.messages = langMessages[this.lang] || langMessages.en;
    },
    showAlert(msg) {
      const alertDiv = document.createElement('div');
      alertDiv.id = "contact-alert";
      alertDiv.style.cssText = 'font-family: siyuan; padding: 6px 20px; color: rgb(255, 255, 255); text-align: center; border-radius: 4px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 999999; background: rgba(0, 0, 0, 0.7); font-size: 16px; transition: -webkit-transform 0.5s ease-in 0s, opacity 0.5s ease-in 0s;';
      alertDiv.textContent = msg;
      document.body.appendChild(alertDiv);
      setTimeout(() => document.body.removeChild(alertDiv), 2500);
    },
    clearForm() {
      this.reportUrl = '';
      this.name = '';
      this.email = '';
      this.phone = '';
      this.messageContent = '';
      this.code = '';
    },
    isValidDomain(domain) {
      const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/;
      return regex.test(domain);
    },
    async handleSubmit() {
      this.setMessages();
      const {
        msg_report_url,
        msg_name,
        msg_email,
        msg_phone,
        msg_verify,
        msg_message_content
      } = this.messages;

      if (this.reportUrl === '') {
        this.showAlert(msg_report_url);
        return;
      }

      if (this.identifyCode != this.code) {
        this.code = null
        return this.$toast(this.$t('CFooters.contact.tips4'));
      }

      if (this.messageStatus === 0) {

        try {
          this.$http('https://www.ebccfd.com/VerificationAuthenticity/Report/', {
            report_url: this.reportUrl,
            lang: this.lang,
          }).then((response) => {
            const da = response.data;
            if (da.code === 1) {
              this.isOfficialResultVisible = false
              this.isOfficialReportVisible = false;
              this.isOfficialReportSuccessVisible = true;
              this.clearForm();
              this.refreshCode();
            } else {
              this.showAlert(da.msg);
            }
          })
        } catch (error) {
          this.showAlert('Error');
        }
      } else {
        if (this.name === '') {
          this.showAlert(msg_name);
          return;
        }
        if (this.email === '') {
          this.showAlert(msg_email);
          return;
        }
        if (this.phone === '') {
          this.showAlert(msg_phone);
          return;
        }
        if (this.messageContent === '') {
          this.showAlert(msg_message_content);
          return;
        }

        try {
          this.$http('https://www.ebccfd.com/VerificationAuthenticity/ReportMessage/', {
            report_url: this.reportUrl,
            name: this.name,
            email: this.email,
            lang: this.lang,
            phone: this.phone,
            message_content: this.messageContent
          }).then((response) => {
            const da = response.data;
            if (da.code === 1) {
              this.isOfficialReportVisible = false;
              this.isOfficialReportSuccessVisible = true;
              this.clearForm();
              this.refreshCode();
            } else {
              this.showAlert(da.msg);
            }
          })
        } catch (error) {
          this.showAlert('Error');
        }
      }
    }
  },
  destroyed() {
    document.documentElement.removeAttribute('data-fitter');
  },
}
</script>

<style scoped>
@charset "UTF-8";

a:hover {
  color: #fff;
}

.transparent {
  background: #fff !important;
}

.topTip {
  position: fixed;
  top: 80px;
  width: 100vw;
  background: linear-gradient(0deg,
      rgba(165, 41, 51, 0.1) 0%,
      rgba(165, 41, 51, 0.1) 100%),
    #fff;
  padding: 13rem 0;
  padding-left: calc((100vw - 1200rem) / 2);
  font-size: 14rem;
  line-height: 22rem;
  font-weight: 400;
  color: var(--ebc-basecolor-active-500);
  z-index: 999;
}

.topTip .medium {
  font-weight: 500;
}

.topTip svg {
  margin-right: 8rem;
}

@media screen and (max-width: 996px) {
  .topTip {
    top: 44px;
    font-size: 24rem;
    line-height: 40rem;
    padding: 16rem 0 16rem 32rem;
    overflow: hidden;
  }

  .topTip svg {
    margin-right: 8rem;
    flex: 0 0 32rem;
    transform: translateY(-3rem);
  }

  .topTip svg:nth-of-type(2) {
    margin-left: 900rem;
  }

  .tickTrack {
    /* display: inline-block; */
    white-space: nowrap;
    animation: scroll-left 20s linear infinite;
  }

  .tickWord {
    display: inline-block;
    /* padding-right: 1rem; */
  }

  @keyframes scroll-left {
    0% {
      transform: translateX(110%);
    }

    100% {
      transform: translateX(-110%);
    }
  }
}

.contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}

.redWord {
  color: var(--ebc-basecolor-active-500);
}

.container1 {
  padding-top: calc(128rem + 80px);
}

.container1 .top .left {
  padding-top: 48rem;
  flex: 0 0 650rem;
}

.container1 .top h2 {
  margin: 24rem 0 48rem;
  color: var(--ebc-text-secondary);
}

.container1 .top .inputBox {
  border-radius: var(--ebc-corner-radius-full);
  border: 0.5px solid var(--ebc-neutral-stroke);
  background: var(--ebc-neutral-bg_b);
  padding: 4rem;
  gap: 30rem;
  padding-left: 24rem;
}

.container1 .top .inputBox input {
  color: var(--ebc-text-tertiary);
  background: var(--ebc-neutral-bg_b);
  border: 0;
  flex: 1;
  height: 100%;
}

.container1 .top .inputBox input::placeholder {
  color: var(--ebc-text-tertiary);
}

.container1 #verification {
  min-width: 160rem;
}

.container1 .right {
  width: 418rem;
  transform:translateX(90rem);
}

.container1 .bottom h2 {
  margin-bottom: 24rem;
}

.container1 .bottom .tipTitle {
  color: var(--ebc-text-primary)
}

.container1 .bottom .tipDesc {
  color: var(--ebc-text-secondary);
  margin-bottom: 16rem;
}

.container1 .bottom .tipDesc:last-child {
  margin-bottom: 0;
}

@media (max-width: 996px) {
  .container1 {
    padding: 122rem 32rem 0;
  }

  .container1 .right {
    width: 558rem;
    height: auto;
    margin-left: 60rem;
    transform:translateX(0rem);
  }

  .container1 .top {
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 80rem;
  }

  .container1 .top .left {
    order: 2;
    position: relative;
    flex: 1;
    padding: 40rem 0 112rem;
  }

  .container1 .top h2 {
    margin: 16rem 0 80rem;
  }

  .container1 .top .left .inputBox {
    padding: 24rem 32rem;
  }

  .container1 .top .left input,
  .container1 .top .left input::placeholder {
    text-align: center;
  }

  .container1 .top #verification {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 80rem;
    font-size: 28rem;
    line-height: 44rem;
  }

  .container1 .bottom h2 {
    margin-bottom: 32rem;
  }

  .container1 .bottom .tipDesc {
    margin-bottom: 24rem;
  }


}

.container2 {
  padding: 120rem 0 60rem;
}

.container2 .cardList {
  margin-top: 60rem;
  gap: 24rem;
}

.container2 .cardList .card {
  background: var(--ebc-neutral-bg_b);
  border-radius: var(--ebc-corner-radius-rc16);
  flex: 1;
  gap: 64rem;
  padding: 24rem;
  border: 0;
}

.container2 .cardList .card .left .description {
  color: var(--ebc-text-secondary);
  margin: 16rem 0;
}

.container2 .cardList .card .left a {
  width: fit-content;
  display: inline-block;
}

.container2 .cardList .card .left .btn {
  border: 0;
  width: fit-content;
  padding: 0;
}

.container2 .cardList .card .right {
  flex: 0 0 156rem;
  height: 156rem;
}

.container22 {
  margin-bottom: 120rem;
}

.container22 .doTitle {
  margin-bottom: 24rem;
}

.container22 .dontDo {
  margin-top: 48rem;
}

.container22 .doTip {
  font-size: 16rem;
  font-weight: 400;
  line-height: 28rem;
  color: var(--ebc-text-secondary);
  margin-bottom: 16rem;
}

.container22 .doTip img {
  margin-right: 8rem;
}

.container22 .doTip .medium {
  font-weight: 500;
  color: var(--ebc-text-primary);
}

@media (max-width: 996px) {
  .container22 {
    padding: 0 32rem 160rem;
    margin-bottom: 0;
  }

  .container22 .doTip {
    font-size: 28rem;
    line-height: 48rem;
   display: flex;
    gap:16rem;
  }
  .container22 .doTip span{
    display: inline-block ;
  }

  .container22 .doTip img {
    width: 32rem;
    height: 32rem;
    transform: translateY(3px);
  }

  .container22 .doTitle {
    margin-bottom: 32rem;
  }

  .container2 {
    padding: 160rem 32rem 80rem;
  }

  .container2 .cardList {
    flex-direction: column;
    gap: 32rem;
  }

  .container2 .cardList .card {
    gap: 16rem;
    padding: 48rem 32rem;
    position: relative;
  }

  .container2 .cardList .card .left {
    order: 2;
  }

  .container2 .cardList .card .left .description {
    margin: 32rem 0 0 0;
  }

  .container2 .cardList .card .left a {
    position: absolute;
    right: 32rem;
    top: 32rem;
  }
}

.container3 {
  padding-bottom: 120rem;
}

.container3 .left {
  flex: 0 0 757rem;
}

.container3 .left .description {
  color: var(--ebc-text-secondary);
  margin: 24rem 0 12rem;
}

.container3 .left .email {
  border-radius: var(--ebc-corner-radius-rc04);
  background: rgba(165, 41, 51, 0.10);
  padding: 4rem 8rem;
  margin-inline: 8rem;
  display: inline-block;
  color: var(--ebc-basecolor-active-500);
  cursor: copy;

}

.container3 .right {
  height: 213rem;
}

@media (max-width: 996px) {
  .container3 {
    padding: 0 32rem 160rem;

  }

  .container3 .contentBox {
    flex-direction: column;
    gap: 80rem;
  }

  .container3 .left {
    flex: 1;
  }

  .container3 .left h3 {
    text-align: center
  }

  .container3 .left .description {
    margin: 80rem 0 24rem;
  }

  .container3 .right {
    height: 400rem;
    margin-inline: auto;
  }
}

.container3 .left .contactWay {
  color: var(--ebc-text-secondary);
}

.official-search button {
  padding: 21px 34px;
  border-radius: 4px;
  border: 1px solid #000;
  background: #4d0101;
  color: #fff;
  font-size: 16px;
  font-family: auto;
  display: inline-block;
  margin-left: 3%;
}

.official-result-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
}

.official-result-box .buttons {
  margin-top: 48rem;
  gap: 24rem;
}

.official-result-box .buttons a {
  flex: 1;
}

.official-result-box .verifyContainer {
  display: flex;
}

.official-result-box .verify-input {
  flex: 1;
}

.official-result-box .verify-code>div {
  width: 160rem;
  height: 56rem;
  margin-left: 16rem;
}

.official-result-box .verify-code>div>div {
  height: 100%;
}

.official-result-box .verify-code canvas {
  width: 100%;
  height: 100%;
}

.official-result {
  width: 588rem;
  padding: 40rem 24rem;
  background-color: #ffffff;
  border-radius: var(--ebc-corner-radius-rc16);
  text-align: center;
  position: absolute;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.official-result svg {
  width: 63rem;
  height: 63rem;
}

.official-result .url {
  display: block;
  padding: 12rem 16rem;
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  margin: 40rem 0;
  overflow: auto;
  border-radius: var(--ebc-corner-radius-rc08);
  background: var(--ebc-neutral-bg_b);
}

.official-result .url.real {
  margin: 40rem 0;
  padding: 12rem 0;
  border-radius: var(--ebc-corner-radius-rc08);
  background: var(--ebc-neutral-bg_b);
}

.official-result .resultTitle {
  margin: 40rem 0 16rem;
}

.official-result .tips {
  color: var(--ebc-text-secondary);
  text-align: center;
  font-family: auto;
  margin: 16rem 0 40rem;
}

/* .official-result .tips.real {
  color: #66b54e;
} */

.official-result .close.real {
  width: 100%;
}

.official-result,
.official-report,
.official-report-success {
  background-image: url('/src/assets/image/OfficialVerification/ebcLogo.png');
}

.official-result .report {
  display: inline-block;
  color: var(--ebc-brand-accent-coral);
  leading-trim: both;
  text-edge: cap;
  float: right;
}

.official-result .mReport {
  display: none;
}

.official-result .report.real {
  display: none;
}

.official-result .tips2 {
  color: var(--ebc-text-tertiary);
  text-align: center;
  margin-top: 24rem;
}

.official-result .tips2.real {
  display: none;
}

.official-report {
  width: 588rem;
  padding: 40rem 24rem;
  background-color: #ffffff;
  border-radius: var(--ebc-corner-radius-rc16);
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;
  max-height: 70vh;
}

.official-report svg {
  margin-right: 8px;
}

.official-report .title {
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  margin-bottom: 48rem;
}

.official-report .contact-submit {
  display: inline-block;
  width: 47%;
  padding: 18px;
  border-radius: 4px;
  border: 1px solid #000;
  background: #4d0101;
  color: #fff;
  leading-trim: both;
  text-edge: cap;
  font-size: 14px;
  font-family: auto;
  margin-top: 40px;
  margin-left: 4%;
}

.official-report .form-label {
  color: var(--ebc-text-secondary);
  font-size: 16rem;
  font-weight: 400;
  line-height: 24rem;
  text-align: left;
  margin-top: 24rem;
  margin-bottom: 12rem;
}

.official-report input:placeholder {
  color: var(--ebc-text-tertiary)
}

.official-report input {
  border: 0;
  display: flex;
  padding: 12rem 16rem;
  justify-content: center;
  align-items: center;
  gap: 16rem;
  color: var(--ebc-text-primary);
  font-family: auto;
  font-size: 20rem;
  font-weight: 400;
  line-height: 24rem;
  background: var(--ebc-neutral-bg_b);
  border-radius: var(--ebc-corner-radius-rc08);
  height: 56rem;
}

.official-report input:focus {
  box-shadow: none;
  background: var(--ebc-neutral-bg_b);
  border: 0;
}

.official-report .message-tips {
  color: var(--ebc-text-secondary);
  font-family: auto;
  margin: 48rem auto;
}

.official-report .message-tips a {
  /* text-decoration: underline; */
  color: var(--ebc-basecolor-active-500)
}

.official-report .message-close-tips a {
  color: var(--ebc-basecolor-active-500);
  width: 100%;
  display: block;
  /* text-decoration: underline; */
}

.official-report-success {
  width: 588rem;
  padding: 40rem 24rem;
  background: #fff;
  border-radius: var(--ebc-corner-radius-rc16);
  text-align: center;
  position: absolute;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.official-report-success p {
  text-align: center;
  margin: 40rem 0 48rem
}


.official-en-box .official1 .p1 {
  letter-spacing: 0px;
  font-size: 30px;
}

.official-en-box .official1 .p2 {
  letter-spacing: 0px;
  font-size: 16px;
  width: 66%;
  opacity: 0.8;
  line-height: 28px;
}

.official-en-box .official1 {
  height: auto;
  padding-bottom: 36px;
}

@media (max-width: 996px) {
  .official-result-box {
    z-index: 9999999999;
  }

  .official-result,
  .official-report,
  .official-report-success {
    width: 100%;
    padding: 40rem 24rem;
    position: absolute;
    top: unset;
    bottom: 0;
    left: 0;
    transform: translate(0, 0);
    overflow: auto;
    max-height: 90vh;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    z-index: 9999999999;
    padding: 48rem;
  }

  .official-report-success {
    padding-top: 160rem;
  }

  .official-result svg {
    width: 96rem;
    height: 96rem;
  }

  .official-result .resultTitle {
    margin: 48rem 0 16rem;
  }

  .official-result .tips {
    margin: 16rem 0 48rem;
  }

  .official-result .pcReport {
    display: none;
  }

  .official-result .mReport {
    display: flex;
    float: none;
    color: var(--ebc-basecolor-active-500);
    font-weight: 500;
  }

  .official-result-box .buttons {
    display: flex;
    gap: 32rem;
    margin: 48rem 0 32rem;
  }

  .official-result-box .buttons a {
    height: 80rem;
    font-size: 28rem;
    font-weight: 500;
  }

  .official-result .url {
    padding: 22rem 32rem;
  }

  .official-result .url.real {
    padding: 18rem 32rem;
  }

  .official-report .message-tips {
    margin: 48rem 0;
  }

  .official-report .message-close-tips a {}

  .official-report .form-label {
    margin: 32rem 0 16rem;
    font-size: 24rem;
    font-weight: 400;
    line-height: 40rem;
  }

  .official-report input {
    font-size: 28rem;
    line-height: 44rem;
    padding: 22rem 32rem;
    height: 80rem;
    border-radius: var(--ebc-corner-radius-rc16);
  }
  .official-result-box .verify-code>div{
    height: 100%;
  }
  .official-result-box .verify-code img {
    width: 228rem;
    height: 80rem;
    margin-left: 32rem;
  }

  .official-result-box .verify-input {
    width: 390rem;
  }

  .official-report-success p {
    margin: 48rem 0 216rem;
  }

  .official-report-success a {
    height: 80rem;
    font-size: 28rem;
    font-weight: 500;
  }
}
</style>
